import { zodResolver } from '@hookform/resolvers/zod'
import { Resolver, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { getOrderFormSchema, OrderFormValues } from './shema'

export const useOrderForm = () => {
  const { t: o } = useTranslation('order')

  const form = useForm<OrderFormValues>({
    resolver: zodResolver(getOrderFormSchema(o)) as Resolver<OrderFormValues>,
    defaultValues: {
      name: '',
      phone: '',
      isOtherPerson: false,
      nameOther: '',
      phoneOther: '',
      address: '',
      isPrivateHouse: false,
      comment: '',
      noIntercomCall: false,
      leaveAtDoor: false,
      replacementOption: 1,
      commentBuilder: '',
      packages: false,
      pickup: false,
    },
  })

  return form
}
